import React from "react"
import { useMeta, useTitle } from "react-meta-elements"
import styled from "styled-components/macro"

import { Background, OuterContainer } from "./common"

import ImageProcessor from "../ImageProcessor"
import { H1 } from "../CopywritingElements"
import MadeByWidget from "../MadeByWidget"
import ContributorByWidget from "../ContributorByWidget"

const EditorPage = () => {
  useTitle(
    "Custom Thumbnails Generator for Vivaldi's Speed Dials | Vivaldi Thumbnail Generator"
  )
  useMeta({
    name: "description",
    content:
      "Custom thumbnail generator for Vivaldi Browser's Speed Dials. Create thumbnails that will match your theme and preferences, quickly and for free!",
  })

  return (
    <>
      <Background />
      <OuterContainer>
        <H1>Vivaldi Thumbnail Generator</H1>

        <ImageProcessor />

        <WidgetRow>
          <MadeByWidget />
          <ContributorByWidget />
        </WidgetRow>

      </OuterContainer >
    </>
  )
}

const WidgetRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

export default EditorPage
